import { ThemeProvider } from "@material-ui/core/styles";
import { GoogleApiWrapper } from "google-maps-react";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import Loader from "./Components/Loaders";
import RootApp from "./Containers/RootApp";
import actions from "./Stores/Auth/actions";
import { persistor } from "./Stores/store";
import { customTheme } from "./theme";
import { ToastContainer } from "react-toastify";
import { validateAndCleanup } from "./utils/tokenValidator";

const googleReferenceAction = actions.setGoogleReference;

function App({ google, setGoogleReference, user }) {
  useEffect(() => {
    (async () => {
      try {
        // Validate token on app initialization
        const isValid = validateAndCleanup();
        if (!isValid && window.location.pathname !== "/") {
          console.warn("⚠️  Invalid or expired token detected on app load");
          // Token was expired and cleared, user will be redirected to login by PrivateRoute
        }

        if (google) {
          await setGoogleReference(google);
        }
      } catch (error) {}
    })();
  }, []);

  return (
    <ThemeProvider theme={customTheme}>
      <Router>
        <PersistGate loading={null} persistor={persistor}>
          <ToastContainer />
          <RootApp />
        </PersistGate>
      </Router>
    </ThemeProvider>
  );
}

const mapStateToProps = (state) => ({
  user: state.AuthReducer.user,
});
const mapStateToDispatch = (dispatch) => ({
  setGoogleReference: (payload) => dispatch(googleReferenceAction(payload)),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch,
)(
  GoogleApiWrapper({
    LoadingContainer: Loader,
    apiKey: process.env.REACT_APP_MAPS_KEYS,
    libraries: ["places, geometry"],
  })(App),
);
